import { StoreCredit } from "./StoreCredit";
import { User } from "./User";

export interface RemoteCard {
    id: ID;
    brand: string;
    expMonth: number;
    expYear: number;
    funding: string;
    last4: string;
    postcode: string;
    name?: string;
    seller: { id: ID };
    paymentMethodType?: PaymentMethodType;
    value?: number;
}

export interface MarketingConsent {
    id: ID;
    label: string;
    value: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface Traveler extends User {
    creditCards?: RemoteCard[];
    isOrganizer?: boolean;
    lifetimeValue?: number;
    value?: number; // An alias of lifetimeValue according to /api/users/:id
    storeCredit?: StoreCredit;
    additionalNames?: string[];
    additionalPhones?: string[];
    additionalEmails?: string[];
    marketingConsents?: MarketingConsent[];
    data?: Data;
    seller?: { id: ID };
    createdAt?: string;
    updated?: string;
}

export interface Data {
    Phone?: string;
    Height?: string;
    Weight?: string;
    Address?: string;
    "Date of birth"?: string; // string YYYY-MM-DD format
    "How did you hear about us?"?: string;
    [key: string]: string | null | undefined;
}

export enum PaymentMethodType {
    INTERAC = "interac_present",
}
